import {Subscription} from '@volkswagen-onehub/feature-hub-utils';
import {FinanceProviderState} from '@volkswagen-onehub/finance-integration-service-types';
import { CAFinanceProviderState, Province, VehicleInterface } from '@vw-marketing/vw-ca-types';
import {useEffect, useState} from 'react';
import { useFinanceStore } from '../store/estimates/finance';
import { useFeatureServices } from '../use-feature-services';
import {_} from './use-lodash';

export const useFinanceProvider = (configuration: VehicleInterface, province?: Province): Subscription | void => {
  const {
    'finance-provider-service': financeProvider,
  } = useFeatureServices();

  const {initLoad, setData, setConfiguration, financeData} = useFinanceStore();

  const [storedUnsubscribe, setStoredUnsubscribe] = useState<Subscription>();

  useEffect(() => {
    if (!financeProvider || !configuration) return;

    if (
      Object.keys(configuration as VehicleInterface).includes('vin')
    ) {
      storedUnsubscribe?.unsubscribe();

      if (Object.keys(financeData).length === 0) {
        initLoad();
      }

      if (province) {
        financeProvider.overrideProvince(province as Province);
      }

      const pageListener = (): void => {
        const financeState = financeProvider.get(
          configuration
        ) as FinanceProviderState<CAFinanceProviderState>;

        if (!financeState || !Object.keys(financeState).length) return;

        const noChanges = _.isEqual(financeState, financeData);
        if (noChanges) {
          return;
        } else {
          setData(financeState);
          setConfiguration(configuration);
        }
      };

      const unsubscribe = financeProvider.subscribe(configuration, pageListener);
      setStoredUnsubscribe(unsubscribe);
    }
  }, [financeProvider, province]);

  useEffect(() => {
  }, [storedUnsubscribe])

  if (storedUnsubscribe) {
    return storedUnsubscribe;
  }
};
